/* Scart - option "faire poser chez un installateur" dans le panier.
   Modèle "on vous recontacte" : le client choisit un garage, stocké en cart attribute
   "Pose chez installateur" -> remonte sur la commande -> alerte interne (Shopify Flow).
   AUCUNE promesse de livraison auto : Scart recontacte le client pour organiser. */
(function () {
  'use strict';
  var FR = (document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0;
  var T = { none: FR ? 'Aucun atelier trouvé' : 'No workshop found' };
  var ATTR = 'Pose chez installateur';

  function fmtValue(g) { return g.nom + ' — ' + g.adresse + ', ' + g.cp + ' ' + g.ville; }

  function init() {
    var root = document.querySelector('[data-cart-installer]');
    if (!root) return;
    var dataEl = root.querySelector('[data-cart-inst-data]');
    var data = [];
    try { data = JSON.parse(dataEl.textContent) || []; } catch (e) {}
    if (!data.length) return;

    var toggle = root.querySelector('[data-inst-toggle]');
    var panel = root.querySelector('[data-inst-panel]');
    var picker = root.querySelector('[data-inst-picker]');
    var search = root.querySelector('[data-inst-search]');
    var list = root.querySelector('[data-inst-list]');
    var selected = root.querySelector('[data-inst-selected]');
    var selName = root.querySelector('[data-inst-sel-name]');
    var selAddr = root.querySelector('[data-inst-sel-addr]');
    var changeBtn = root.querySelector('[data-inst-change]');
    var current = root.getAttribute('data-current') || '';

    function post(val) {
      root.classList.add('scart-cart-inst__busy');
      var attrs = {}; attrs[ATTR] = val;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) { return r.json(); })
        .catch(function () {})
        .then(function () { root.classList.remove('scart-cart-inst__busy'); });
    }

    function renderList(filter) {
      list.innerHTML = '';
      var f = (filter || '').trim().toLowerCase();
      var shown = data.filter(function (g) {
        if (!f) return true;
        return (g.ville + ' ' + g.cp + ' ' + g.nom).toLowerCase().indexOf(f) !== -1;
      });
      if (!shown.length) {
        var empty = document.createElement('li');
        empty.className = 'scart-cart-inst__empty';
        empty.textContent = T.none;
        list.appendChild(empty);
        return;
      }
      shown.forEach(function (g) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'scart-cart-inst__item';
        var n = document.createElement('span');
        n.className = 'scart-cart-inst__item-name';
        n.textContent = g.nom;
        var l = document.createElement('span');
        l.className = 'scart-cart-inst__item-loc';
        l.textContent = g.cp + ' · ' + g.ville;
        b.appendChild(n); b.appendChild(l);
        b.addEventListener('click', function () { choose(g); });
        li.appendChild(b);
        list.appendChild(li);
      });
    }

    function showSelected(g) {
      selName.textContent = g.nom;
      selAddr.textContent = g.adresse + ', ' + g.cp + ' ' + g.ville;
      picker.hidden = true;
      selected.hidden = false;
    }
    function showList() {
      selected.hidden = true;
      picker.hidden = false;
      renderList(search.value);
    }
    function choose(g) { post(fmtValue(g)).then(function () { showSelected(g); }); }
    function clearSel() { post('').then(function () { selected.hidden = true; }); }

    toggle.addEventListener('change', function () {
      if (toggle.checked) { panel.hidden = false; showList(); }
      else { panel.hidden = true; clearSel(); }
    });
    changeBtn.addEventListener('click', showList);
    search.addEventListener('input', function () { renderList(search.value); });

    renderList('');
    if (current) {
      var match = null;
      for (var i = 0; i < data.length; i++) { if (fmtValue(data[i]) === current) { match = data[i]; break; } }
      toggle.checked = true;
      panel.hidden = false;
      if (match) showSelected(match);
      else showList();
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
